export enum TransactionReason {
  LeadHold = 1,
  LeadApprove = 2,
  LeadReject = 3,
}
